import InfoContainer from './info-container';

export default InfoContainer;
